import { Button, useModal } from "@newsela/angelou";
import PropTypes from "prop-types";

import ContentDisplayDetailsRow from "../ContentDisplayDetailsRow";
import StandardsModal from "./StandardsModal";
import { standardsCss, standardsButtonCss } from "./StandardsRow.style";

const propTypes = {
  contentMetadata: PropTypes.array,
};

const StandardsRow = ({ contentMetadata }) => {
  const [modalProps, setActive, triggerRef] = useModal(false);

  const standards = contentMetadata?.filter(
    (datum) => datum.content_type === "STANDARD",
  );

  if (standards?.length === 0) return null;

  const standardsLabel = `Standards (${standards?.length})`;

  const getStandardsValue = () => {
    const standardNames = standards?.map((standard) => standard.data.name);
    const isTruncatedList = standardNames?.length > 3;

    return (
      <>
        <span css={standardsCss}>
          {standardNames?.slice(0, 3).join(", ")}
          {isTruncatedList ? "..." : ""}
        </span>
        <Button
          __cssFor={{ root: standardsButtonCss }}
          flavor={Button.flavors.tertiary}
          size={Button.sizes.md}
          onClick={() => setActive(true)}
          ref={triggerRef}
        >
          {isTruncatedList ? "View all" : "View details"}
        </Button>
      </>
    );
  };

  const standardsRowData = [
    { label: standardsLabel, value: getStandardsValue() },
  ];

  return (
    <>
      <ContentDisplayDetailsRow row={standardsRowData} key="standards" />
      <StandardsModal
        standards={standards}
        standardsLabel={standardsLabel}
        setActive={setActive}
        modalProps={modalProps}
      />
    </>
  );
};

StandardsRow.propTypes = propTypes;

export default StandardsRow;
